module.exports = __webpack_public_path__ + "static/media/wait.9434b9ce.mp3";